export const LOGO_STATIC_URI = require('../../assets/images/vlinder-logo.png');

